module.exports = __webpack_public_path__ + "img/Flow_ISE@3x.68ee4b03.png";